import React from 'react';
import HireMe from './HireMe';
import { HashLink as Link } from 'react-router-hash-link';



const Header = () => {
  return (

      <div className="header" id="header">
        <div className="container">
          <Link to="/" className="logo"><img className="logo-img" src="imgs/Mohamed abi.png" alt="" /></Link>
          <ul className="main-nav">
            <li><Link to="/#projects">Projects</Link></li>
            <li><Link to="#tools" smooth>Tools</Link></li>
            <li><Link to="#pricing" smooth>About us</Link></li>
            <li><Link to="/certifications" smooth>certifications</Link></li>
            <HireMe/>
            
          </ul>
        </div>
      </div>

  );
};

export default Header;
